// extracted by mini-css-extract-plugin
module.exports = {"FAQCard":"FAQCard-module--FAQCard--2QDrC","ques":"FAQCard-module--ques--Ucq0E","ans":"FAQCard-module--ans--2CAGt"};